import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { TextArea } from "@/components/TextArea/TextArea";

interface SignOffStyleSectionProps {
	value: string;
	onChange: (value: string) => void;
}

export const SignOffStyleSection: FunctionComponent<SignOffStyleSectionProps> = ({
	value,
	onChange,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`copywritingSettings.signOffStyle.${key}`);

	return (
		<div className="flex flex-col gap-4">
			<p className="text-sm text-text-meta">{ts("description")}</p>

			<TextArea
				handleChange={(e) => onChange(e.target.value)}
				name="signOffStyle"
				placeholder={ts("placeholder")}
				showError={false}
				value={value}
			/>
		</div>
	);
};
